import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, Add as AddIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { getInstallers } from '../../data/Installers/actions';

class CommercialAgent extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        getInstallers: PropTypes.func.isRequired,
        installers: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshInstallers();
    }

    refreshInstallers = () => {
        const { getInstallers } = this.props;
        this.setState({ loading: true });
        return getInstallers()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `installer/detail/${rowData.id}` });
    };
    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'installer/add' });
    };

    renderData = memoizeOne(installers => {
        let results = [];

        installers.map((installer, id) => {
            results.push({
                id,
                company: installer.get('company'),
                username: installer.get('username'),
                lastname: installer.get('lastname'),
                firstname: installer.get('firstname'),
                phone: installer.get('phone'),
                email: installer.get('email'),
                isActive: installer.get('isActive')
                    ? Translator.translate('general.installer-active')
                    : Translator.translate('general.installer-inactive')
            });
        });

        return results;
    });

    renderActions = memoizeOne(profile => {
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate('generic.installer.table.globalAction.refresh.tooltip'),
                    onClick: this.refreshInstallers
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate('generic.installer.table.globalAction.add.tooltip'),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate('general.showDetail'),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { classes } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.company'),
                name: 'company'
            },
            {
                title: Translator.translate('general.table.column.username'),
                name: 'username',
                action: (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.phone'),
                name: 'phone'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.isActive'),
                name: 'isActive',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.installer-active') ? classes.active : classes.inactive}>
                            {value}
                        </span>
                    );
                }
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { profile, installers } = this.props;

        return (
            <FHETable
                idTable="installerList"
                columns={this.renderColumns(profile)}
                data={this.renderData(installers)}
                actions={this.renderActions(profile)}
                title={Translator.translate('generic.installer.table.title')}
                emptyDataSourceMessage={Translator.translate('generic.installer.table.body.emptyDataSourceMessage')}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
        installers: state.environments.fhe.data.Installers.get('list'),
        initialized: state.environments.fhe.data.Installers.get('initialized')
    };
}

const styles = theme => ({
    active: {
        color: theme.palette.success.main
    },
    inactive: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getInstallers }, dispatch)
    )(withStyles(styles, { withTheme: true })(CommercialAgent))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Installer/index.js